export const getOrigins = () => {
    let origins = ''
    try {
        origins = Array.from(window.location.ancestorOrigins ?? [])?.join(', ')
    } catch (e) {
        console.error(e)
    }
    return origins
}
